import { type FC } from 'react';

import Box from 'app/components/v2/components/Box';
import Icon from 'app/components/v2/components/Icon';
import { type IconName } from 'app/components/v2/components/Icon/types';

type Type = 'invoices' | 'paperwork' | 'payments';

interface LabelConfig {
  iconName: IconName;
  label: string;
}

const labelType: Record<Type, LabelConfig> = {
  invoices: {
    iconName: 'file',
    label: 'Invoices',
  },
  paperwork: {
    iconName: 'receipt',
    label: 'Paperwork',
  },
  payments: {
    iconName: 'money',
    label: 'Payments',
  },
};

interface Props {
  type: Type;
}

const PayeeGlobalSearchLabel: FC<Props> = ({ type }) => {
  const config = labelType[type];

  return (
    <Box
      alignItems="center"
      display="flex"
      gap={2}
    >
      <Icon
        color="inherit"
        name={config.iconName}
        size="xxs"
      />

      {config.label}
    </Box>
  );
};

export default PayeeGlobalSearchLabel;
